export enum EAutoPaymentBEErrors {
  TooManyCards = 'Company can attach only one card',
  IncorrectCardNumber = 'Your card number is incorrect.',
  InsufficientFunds = 'Insufficient funds',
  AmountLess05 = 'amount must not be less than 0.5',
  PeriodLess1 = 'period must not be less than 1'
}
